import RegistrationModal from './RegistrationModal'

export default function RegistrationPage() {
  const handleClose = () => {
    // Do nothing - let the RegistrationModal component handle navigation
  }

  return (
    <div className="relative min-h-screen bg-black overflow-hidden">
      {/* Content */}
      <div className="relative z-10">
        <RegistrationModal
          isOpen={true}
          onClose={handleClose}
          onSwitchToSignIn={() => window.location.href = '/login'}
        />
      </div>
    </div>
  )
}
